// 2026-11-05 (feedback pipeline): failures the api files itself (api/src/pipeline/autofile.ts), so the user is told
// they needn't report them. Pure (unit-tested in pipeline.test.ts).

export const LOGGED_LINE = "We logged this, so you don't need to report it.";

/** A failed job the api filed itself: our side went wrong (errorCode provider / timeout), not a busy service, a
 *  filter, the spend cap, their own stop or one of our checks. */
export const jobWasLogged = (j: { status?: string; errorCode?: string | null; error?: string | null }) =>
  j.status === "failed" && (j.errorCode === "provider" || j.errorCode === "timeout") && !/busy right now|out of credit/i.test(j.error ?? "");

/** A failed render the api filed itself (its message is one of pipeline.ts friendlyError's system lines). */
export const renderWasLogged = (error: string | null | undefined) => /generators had a problem|Something went wrong making the video/i.test(error ?? "");
